import { observer } from 'mobx-react-lite';
import { FollowUpTable } from '../../../app/stores/FilmAnaysisAndRepairReport/types';
type JsonMetadataItem = {
  [key: string]: {
    [key: string]: string;
  };
};

interface DynamicTableProps {
  elementObject: JsonMetadataItem[];
  indexValue: number;
  dryingOrDesiccation?: any;
}

export const FilmReportMetadataDynamicTable: React.FC<DynamicTableProps> = ({
  elementObject,
  indexValue = 0,
  dryingOrDesiccation,
}) => {
  if (!Array.isArray(elementObject)) {
    return null; // Or handle this case as needed
  }
  return (
    <>
      <table className="table">
        <tbody>
          {indexValue === 0 && (
            <>
              <tr>
                <td className="table-td-key ">Process</td>
                <td className="table-td-value">Fields to be captured</td>
                <td className="table-td-value padding-Right">
                  Fields to be updated
                </td>
              </tr>
              <tr>
                <td className="table-td-key">Treatment</td>
                <td className="table-td-value">
                  {dryingOrDesiccation?.Treatment?.split('|')[0]}
                </td>
                <td className="table-td-value padding-Right">
                  :{dryingOrDesiccation?.Treatment?.split('|')[1]}
                </td>
              </tr>
              <tr>
                <td className="table-td-key">
                  Set Up Used For Dessication/ Rehydration Along With Any
                  Specific Settings
                </td>
                <td className="table-td-value ">
                  {
                    dryingOrDesiccation?.set_up_used_for_dessication_rehydration_along_with_any_specific_setting
                  }
                </td>
                <td className="table-td-value padding-Right"></td>
              </tr>
              <tr>
                <td className="table-td-key"> Chemicals Used For Treatment</td>
                <td className="table-td-value ">
                  {
                    dryingOrDesiccation?.chemicals_used_for_tratment?.split(
                      '|',
                    )[0]
                  }
                </td>
                <td className="table-td-value padding-Right">
                  :{' '}
                  {
                    dryingOrDesiccation?.chemicals_used_for_tratment?.split(
                      '|',
                    )[1]
                  }
                </td>
              </tr>
            </>
          )}
          {elementObject.map(
            (json, jsonIndex) =>
              json &&
              typeof json === 'object' &&
              Object.entries(json).map(
                ([process, fields]) =>
                  fields &&
                  typeof fields === 'object' &&
                  Object.entries(fields).map(
                    ([fieldName, fieldValue], fieldIndex) => {
                      if (FollowUpTable?.[indexValue]?.includes(process)) {
                        return (
                          <tr key={jsonIndex + '-' + fieldIndex}>
                            {fieldIndex === 0 ? (
                              <td
                                className={
                                  process === 'Process'
                                    ? 'table-td-key'
                                    : 'table-td-key '
                                }
                                rowSpan={Object.keys(fields).length}
                              >
                                {process
                                  ?.replaceAll('_', ' ')
                                  ?.replace(/^(.)/, (match) =>
                                    match.toUpperCase(),
                                  )}
                              </td>
                            ) : (
                              <td className="table-td-key"></td>
                            )}
                            <td
                              className="table-td-value"
                              colSpan={
                                fieldName === 'Industrial Dessication Chamber '
                                  ? 3
                                  : 0
                              }
                            >
                              {fieldName
                                ?.replaceAll('followup_', '')
                                ?.replaceAll('DateandTime', 'date_and_time')
                                ?.replaceAll('_', ' ') // Replace underscores with spaces
                                ?.replace(/^(.)/, (match) =>
                                  match.toUpperCase(),
                                )}
                            </td>
                            <td className="table-td-value padding-Right">
                              :{' '}
                              {fieldValue
                                ?.replaceAll('_', ' ')
                                ?.replace(/^(.)/, (match) =>
                                  match.toUpperCase(),
                                )}
                            </td>
                          </tr>
                        );
                      }
                      return null; // Skip rendering if index is more than 5
                    },
                  ),
              ),
          )}

          {indexValue === 3 && (
            <>
              <tr>
                <td className="padding-left">
                  No. Of Days For Treatment In Desiccation / Rehydration
                </td>
                <td className="table-td-value">
                  {
                    dryingOrDesiccation?.no_of_days_for_treatment_in_desiccation_rehydration
                  }
                </td>
              </tr>
              <tr>
                <td className="table-td-key padding-left">
                  8 Weeks - (Status Or Condition After 8 Weeks)
                </td>
                <td className="table-td-value">
                  {
                    dryingOrDesiccation?.eight_weeks_status_or_condition_after_8_weeks
                  }
                </td>
              </tr>
              <tr>
                <td className="table-td-key padding-left">
                  {' '}
                  Next Process Recommended
                </td>
                <td className="table-td-value">
                  {dryingOrDesiccation?.next_process_recommed}
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
      <table></table>
    </>
  );
};

export default observer(FilmReportMetadataDynamicTable);
